import { render, staticRenderFns } from "./activitySetting.vue?vue&type=template&id=b60d1d22&scoped=true"
import script from "./activitySetting.vue?vue&type=script&lang=js"
export * from "./activitySetting.vue?vue&type=script&lang=js"
import style0 from "./activitySetting.vue?vue&type=style&index=0&id=b60d1d22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60d1d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60d1d22')) {
      api.createRecord('b60d1d22', component.options)
    } else {
      api.reload('b60d1d22', component.options)
    }
    module.hot.accept("./activitySetting.vue?vue&type=template&id=b60d1d22&scoped=true", function () {
      api.rerender('b60d1d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/activitySetting.vue"
export default component.exports